import React from 'react'
import { Box, Grid, Typography } from '@mui/material';

const TranInfoView = ({ transInf }) => {
    if (!transInf) {
        return null;
    }

    return (
        <Box>
            {transInf.trnTyp === 'D' && (
                <Grid
                    item
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
                >
                    <Grid item xs={2}>
                        <Typography variant="subtitle2" component="div">폐기 타입</Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{transInf?.trnToWh}</Typography>
                    </Grid>
                </Grid>
            )}
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div">등록자</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2" component="div">{transInf?.crtNm}</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div">등록일</Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="body2" component="div">{transInf?.crtDt}</Typography>
                </Grid>
            </Grid>
            <Grid
                item
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
            >
                <Grid item xs={2}>
                    <Typography variant="subtitle2" component="div">사유</Typography>
                </Grid>
                <Grid item xs={10}>
                    <Typography sx={{ whiteSpace: 'pre-line' }} variant="body2" component="div">{transInf?.trnDesc}</Typography>
                </Grid>
            </Grid>
        </Box>
    )
}
export default TranInfoView